import { render, staticRenderFns } from "./history-tui.vue?vue&type=template&id=73d990da&scoped=true&"
import script from "./history-tui.vue?vue&type=script&lang=js&"
export * from "./history-tui.vue?vue&type=script&lang=js&"
import style0 from "./history-tui.vue?vue&type=style&index=0&id=73d990da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d990da",
  null
  
)

export default component.exports